// From first two functions (in string form) to type
// returns type as a string
function getTypeFromFunctions(first, second) {
    var type = "";
    
        if (first.substring(1, 2) === "i") {
            type += "I";

            if (first.substring(0, 1) === "N" || second.substring(0, 1) === "N") type += "N";
            else type += "S";

            if (first.substring(0, 1) === "T" || second.substring(0, 1) === "T") type += "T";
            else type += "F";

            if (first.substring(0, 1) === "N" || first.substring(0, 1) === "S") type += "J";
            else type += "P";

        } else {
            type += "E";

            if (first.substring(0, 1) === "N" || second.substring(0, 1) === "N") type += "N";
            else type += "S";

            if (first.substring(0, 1) === "T" || second.substring(0, 1) === "T") type += "T";
            else type += "F";

            if (first.substring(0, 1) === "N" || first.substring(0, 1) === "S") type += "P";
            else type += "J";
        }
    return type;
}

export { getTypeFromFunctions }